export function getPortugueseValueCron(option) {
  const translations = {
    clear_all_cash_register: 'Fechar todos os Caixas',
    clear_tags: 'Limpar as Comandas/Tags',
    clear_promotions: 'Limpar uso das promoções',
    clear_host_queue: 'Limpar a fila de espera',
    close_events: 'Fechar Eventos Abertos'
  }

  return translations[option] || null
}
